import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f44288e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-default inner-quickview inner-icon" }
const _hoisted_2 = { class: "label-group" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-icon-group" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn-icon product-type-simple link" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-shopping-cart" })
  ])
], -1))
const _hoisted_4 = { class: "product-details" }
const _hoisted_5 = { class: "title-wrap" }
const _hoisted_6 = { class: "product-title" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Call for pricing ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ext. 1 ")
const _hoisted_13 = {
  class: "price-box",
  key: "singlePrice"
}
const _hoisted_14 = { class: "product-price" }
const _hoisted_15 = {
  key: 0,
  class: "product-action"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-shopping-cart" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add to Cart", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "info-custom"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Call for pricing ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" ext. 1 ")
const _hoisted_25 = {
  key: 1,
  class: "login"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Please ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Sign In")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Join")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" to order ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_input = _resolveComponent("v-input")!
  const _component_cart_popup = _resolveComponent("cart-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", null, [
      _createVNode(_component_v_slider, {
        slides: _ctx.product?.images
      }, null, 8, ["slides"]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.product?.condition)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product-label label-hot",
              style: _normalizeStyle(_ctx.conditionLabel(_ctx.product.condition))
            }, _toDisplayString(_ctx.product.condition.split('_').join(' ')), 5))
          : _createCommentVNode("", true)
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: { name: 'Shop', params: { id: _ctx.product?.id } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.product?.product?.manufacturer.name) + " " + _toDisplayString(_ctx.product?.product?.product_description) + " " + _toDisplayString(_ctx.product?.product?.mpn), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.product?.unlimited_quantity ? 'Unlimited available' : `${_ctx.product?.quantity} available`), 1),
      (!_ctx.product?.sell_price && !_ctx.isUserLoggedIn)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("a", {
              href: `tel:${_ctx.CONTACT_PHONE_NUMBER}`,
              class: "phone"
            }, _toDisplayString(_ctx.CONTACT_PHONE_NUMBER), 9, _hoisted_11),
            _hoisted_12
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.product?.sell_price)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, "$" + _toDisplayString(_ctx.product.sell_price.toFixed(2)), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    (_ctx.isUserLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          (_ctx.product?.sell_price)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_v_input, {
                  type: "number",
                  modelValue: _ctx.quantity,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quantity) = $event)),
                  min: 1,
                  class: _normalizeClass({ 'is-invalid': !_ctx.validQty }),
                  max: _ctx.totalAvailable
                }, null, 8, ["modelValue", "class", "max"]),
                _createElementVNode("a", {
                  href: "javascript:;",
                  class: _normalizeClass(["btn btn-icon btn-add-cart product-type-simple", { disabled: !_ctx.validQty }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToCart(_ctx.product))),
                  disabled: !_ctx.validQty,
                  key: "thumbForm"
                }, _hoisted_19, 10, _hoisted_16)
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _createElementVNode("a", {
                  href: `tel:${_ctx.CONTACT_PHONE_NUMBER}`,
                  class: "phone"
                }, _toDisplayString(_ctx.CONTACT_PHONE_NUMBER), 9, _hoisted_23),
                _hoisted_24
              ]))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_25, [
          _hoisted_26,
          _createVNode(_component_router_link, {
            to: { name: _ctx.LOGIN }
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_28,
          _createVNode(_component_router_link, {
            to: { name: _ctx.REGISTER }
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_30
        ])),
    _createVNode(_component_cart_popup, { class: "minipopup-area" })
  ]))
}